import React from "react";

const FirstPage = ({ onContinue }) => {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center cursor-pointer"
      style={{ backgroundColor: "#FF99FF" }}
      onClick={onContinue}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onContinue();
        }
      }}
    >
      <div className="w-[80%] flex flex-col items-center justify-between h-full py-16 px-8">
        <img
          src="/images/firstLogo.svg"
          alt="Illustration"
          className="w-full max-w-md"
        />
      </div>
      <div className="w-[99%]">
        <img
          src="/images/home.svg"
          alt="home"
          className="w-auto max-w-[100%] h-auto"
        />
      </div>
      <div className="text-center mt-10">
        <h2 className="font-young-serif text-[42px] leading-[47px] text-[#1E0A1E]">
          More
          <br />
          meaningful
          <br />
          moments
        </h2>
      </div>
    </div>
  );
};

export default FirstPage;